import React from "react";

import { ElectronicReceiptsCellContent as Content } from "../components";

import base from "./base";
import { Column, ColumnId } from ".";

function electronicReceipts({ width, onResize }: Column.Options) {
	return base(ColumnId.ElectronicReceipts, (item) => <Content item={item} />, {
		width,
		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default electronicReceipts;
